import React from "react";

import Image from "next/image";
import CloseIcon from "public/icons/close.svg";
import SpringImgLeft from "public/images/spring-banner-left.png";

import { css, styled } from "@mui/material";

import { Button } from "@/components/form/Button/Button";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";
import { clsxm } from "@/utils/tailwindMerge";

import { useSecondaryLayoutTopBannerContext } from "../context";

export const SpringBanner: React.FC = () => {
  const { closeBanner } = useSecondaryLayoutTopBannerContext();

  const { openModal, removeOne } = useOpenModal();

  const openRegisterModal = () =>
    openModal("REGISTER_FORM_MODAL", {
      onClose: removeOne,
    });

  return (
    <div className="w-screen ml-[calc(-50vw_+_50%)]">
      <div className="flex justify-center bg-pink relative">
        <div className="h-full w-full">
          <div
            className={clsxm(
              "relative overflow-clip w-full",
              "flex justify-center items-center",
              "md:h-[54px] h-[80px]",
            )}
          >
            <LeftDesktopImage src={SpringImgLeft} alt="Valentines Day Offer" />

            <RightDesktopImage src={SpringImgLeft} alt="Valentines Day Offer" />

            <LeftMobileImage src={SpringImgLeft} alt="Valentines Day Offer" />

            <RightMobileImage src={SpringImgLeft} alt="Valentines Day Offer" />

            <div className="flex flex-col items-center gap-1 md:gap-2 md:flex-row z-[1]">
              <div className="text-white text-base md:text-2xl [text-shadow:_#FB3C6C_0px_0_10px,_#FB3C6C_0px_0_10px,_#FB3C6C_0px_0_10px]">
                <span className="font-bold text-[#FFFFFF]">
                  CashbackCoins Deal:
                </span>{" "}
                <span className="font-light">07-16 </span>
                <span className="text-xs md:text-sm">March</span>
              </div>
              <Button
                onClick={openRegisterModal}
                className="bg-[#FFFFFF] hover:bg-[#FFFFFF] text-[#FB3C6C] text-sm h-7"
              >
                Purchase coins
              </Button>
            </div>
          </div>
        </div>
        <Button
          variant="outlined"
          onClick={closeBanner}
          className={clsxm(
            "h-[32px] w-[32px] min-w-min p-0 absolute z-[1]",
            "md:right-4 md:top-1/2 md:transform md:-translate-y-1/2",
            "right-2 top-1",
            "border-none hover:border-none hover:bg-white hover:bg-opacity-90",
          )}
          startIcon={
            <SvgCloseIcon>
              <CloseIcon />
            </SvgCloseIcon>
          }
        ></Button>
      </div>
    </div>
  );
};

const SvgCloseIcon = styled(SvgIcon)({
  "& path": {
    fill: "black",
  },
});

const LeftDesktopImage = styled(Image)(
  ({ theme }) => css`
    scale: 0.5;

    position: absolute;
    left: -19.5rem;
    top: -8.9rem;
    max-width: none;

    display: none;
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: block;
    }
  `,
);

const RightDesktopImage = styled(Image)(
  ({ theme }) => css`
    scale: -0.5 0.5;

    position: absolute;
    right: -19.5rem;
    top: -7.6rem;
    max-width: none;

    display: none;
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: block;
    }
  `,
);

const LeftMobileImage = styled(Image)(
  ({ theme }) => css`
    scale: 0.5;

    position: absolute;
    left: -15.1rem;
    top: -11.3rem;
    max-width: none;

    display: block;
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: none;
    }
  `,
);

const RightMobileImage = styled(Image)(
  ({ theme }) => css`
    scale: -0.5 0.5;

    position: absolute;
    right: -15.1rem;
    top: -11.3rem;
    max-width: none;

    display: block;
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: none;
    }
  `,
);
